export class TipoEstado {
    idAdmTipoEstado:number;
    nombre:string;
}